import { IconButton } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

import { useDisclosure } from '@hooks/useDisclosure';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import ProductIncomeModal from '../ProductIncomeModal/ProductIncomeModal';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';

type ProductIncomeEditButtonProps = {
  keyItem: string;
};

const ProductIncomeEditButton = ({ keyItem }: ProductIncomeEditButtonProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, watch } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const productIncomeItems = getValues(
    'incomeStructure.productIncomeItems'
  ) as IIncomeStructureFormValues['productIncomeItems'];
  const editData = productIncomeItems[keyItem].incomeCategory;

  return (
    <>
      <IconButton
        color="inherit"
        size="small"
        sx={{ padding: 0 }}
        onClick={open}
        disabled={isCompletedTh && isCompletedEn}
      >
        <EditOutlinedIcon style={{ fontSize: '14px' }} />
      </IconButton>
      {opened && (
        <ProductIncomeModal
          mode="edit"
          open={opened}
          close={close}
          keyItem={keyItem}
          editData={editData}
        />
      )}
    </>
  );
};

export default ProductIncomeEditButton;
